/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  Tooltip,
} from '@mui/material';
import { FaEdit, FaWindowClose, FaExclamation } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ptBR } from '@mui/material/locale';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import axios from '../../services/axios';
import * as colors from '../../config/colors';

function DataTable({ columns, data, tableData, tableRoute }) {
  const [table, setTable] = useState([]);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const theme = useTheme(); // replace with your theme/createTheme

  useEffect(() => {
    setTable(data);
  }, [data]);

  const handleDeleteAsk = (id) => {
    setDeleteConfirmId(id);
  };

  const handleDelete = async (e, id, index) => {
    e.persist();

    try {
      await axios.delete(`/${tableData}/${id}`);
      const newTable = [...table];
      newTable.splice(index, 1);
      setTable(newTable);
      toast.success('Registro excluído com sucesso!');
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login como Administrador!');
      } else if (status === 400) {
        toast.error(
          'Registro não pode ser excluído: Relacionamento entre tabelas!'
        );
      } else {
        toast.error(`Ocorreu um erro ao excluir registro!`);
      }
    } finally {
      setDeleteConfirmId(null);
    }
  };

  return (
    <ThemeProvider theme={createTheme(theme, ptBR)}>
      <MaterialReactTable
        columns={columns}
        data={table}
        // enableColumnFilterModes
        enableColumnOrdering
        // enableEditing
        // enablePinning
        enableRowActions
        // enableRowSelection
        // enableSelectAll={false}
        initialState={{
          density: 'compact',
          showColumnFilters: false,
          showGlobalFilter: false,
          columnVisibility: { id: false },
        }}
        localization={MRT_Localization_PT_BR}
        renderRowActions={({ row }) => (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip arrow placement="left" title="Editar">
              <Link to={`/${tableRoute}/${row.getValue('id')}/edit`}>
                <FaEdit size={16} />
              </Link>
            </Tooltip>
            <Tooltip arrow placement="right" title="Excluir">
              <div>
                {deleteConfirmId === row.getValue('id') ? (
                  <FaExclamation
                    size={16}
                    color={colors.errorColor}
                    cursor="pointer"
                    onClick={(e) => handleDelete(e, row.getValue('id'), row.id)}
                  />
                ) : (
                  <FaWindowClose
                    size={16}
                    color={colors.primaryColor}
                    cursor="pointer"
                    onClick={() => handleDeleteAsk(row.getValue('id'))}
                  />
                )}
              </div>
            </Tooltip>
          </Box>
        )}
      />
    </ThemeProvider>
  );
}

export default DataTable;
